const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLottoSuperrich',
    accessToken: 'accessTokenLottoSuperrich',
    userRole: 'userRole'
  }
}

export default AppConfig;
